import { MODAL_SHOW, NEW_SELF_INSPECTION, SET_SELF_INSPECT_DATA, MODAL_TYPE_ERROR, SET_CUSTOMER_DATA, LOADING_SCREEN_HIDE, LOADING_SCREEN_SHOW, MODAL_HIDE, MODAL_TYPE_SUCCESS, SET_INSPECTION_ITEMS } from "../constants/constants";
import { navigateTo } from './navigationActions';
import { CAPTURE_CONDITIONS, CAPTURE_IMAGES, COMPLETE, DASHBOARD, SELF_INSPECTION } from "../routes/routes";
import { logErrorToDatabase, postToController } from "./apiActions";
import { ERROR_HEADER, ERROR_INSPECTION_PHOTOS, ERROR_SOMETHING_WENT_WRONG } from "../constants/copy";
import { logEvent } from "../firebase/firebase";

export const addSelfInspect = () => {
    return async (dispatch, getState) => {
        await dispatch({
            type: NEW_SELF_INSPECTION
        });

        await dispatch(navigateTo(CAPTURE_IMAGES));
    };
}

export const setMileage = (mileageData: string) => {
    return async (dispatch) => {
        await dispatch({
            type: SET_SELF_INSPECT_DATA, payload: {
                mileage: mileageData,
            },
        });
        await dispatch(navigateTo(CAPTURE_IMAGES));
    };
}

export const syncCoverWithProfile = () => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_SELF_INSPECT_DATA, payload: {
                selectedPersonalCover: getState().profile.selectedPersonalCover
            },
        });
        await dispatch(navigateTo(SELF_INSPECTION));
    };
}

export function setSelectedCoverSelfInspect(coverId) {
    return async (dispatch, getState) => {
        var policies = getState().profile.selectedPersonalPolicy;
        let selectedCover = null;
        if (policies !== undefined) {
            for (var i = 0; i < policies.covers.length; i++) {
                var cover = policies.covers[i];
                if (cover.isMainline === true && cover.id === coverId) {
                    selectedCover = cover;
                    break;
                }
            };
        }

        if (selectedCover !== null) {
            await dispatch({
                type: SET_CUSTOMER_DATA, payload: {
                    selectedPersonalCover: selectedCover,
                }
            });
            await dispatch({
                type: SET_SELF_INSPECT_DATA, payload: {
                    selectedPersonalCover: selectedCover,
                },
            });
            await dispatch(navigateTo(SELF_INSPECTION));
        }
    }
}

export const saveCarDetails = (vinNr: string, regNr: string, licenceNr: string, licenceExpDate: string, engineNr: string, make: string, model: string) => {
    return async (dispatch) => {
        await dispatch({
            type: SET_SELF_INSPECT_DATA, payload: {
                vinNo: vinNr,
                regNo: regNr,
                licenceNo: licenceNr,
                licExpiryDate: licenceExpDate,
                engineNo: engineNr,
                make: make,
                model: model,
            },
        });
        dispatch(navigateTo(CAPTURE_CONDITIONS));
    };
}

export const saveCarCondition = (upholsteryDamageAnswer: string, paintDamageAnswer: string, hailDamageAnswer: string, carRebuiltAnswer: string) => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_SELF_INSPECT_DATA, payload: {
                upholsteryDamage: upholsteryDamageAnswer,
                paintDamage: paintDamageAnswer,
                hailDamage: hailDamageAnswer,
                carRebuilt: carRebuiltAnswer,
            },
        });
    }
}

export const submitSelfInspect = () => {
    return async (dispatch, getState) => {
        var riskItemType = 6
        if (getState().selfInspect.selectedPersonalCover.productName === "Motorbike") {
            riskItemType = 7
        }
        var success = true
        logEvent('SSP_submit_self_inspect', getState().selfInspect.selectedPersonalCover.riskItems[0].id);
        await postToController(dispatch, 'SubmitSelfInspection',
            JSON.stringify({
                RiskItemId: getState().selfInspect.selectedPersonalCover.riskItems[0].riskItemId,
                PolicyRiskItemId: getState().selfInspect.selectedPersonalCover.riskItems[0].id,
                VINNumber: getState().selfInspect.vinNo,
                LicenseNumber: getState().selfInspect.licenceNo,
                RegistrationNumber: getState().selfInspect.regNo,
                RegisterNumber: getState().selfInspect.regNo,
                ExpiryDate: getState().selfInspect.licExpiryDate,
                Manufacturer: getState().selfInspect.make,
                Model: getState().selfInspect.model,
                Year: 1900,
                EngineNumber: getState().selfInspect.engineNo,
                UpholsteryDamage: (getState().selfInspect.upholsteryDamage === 'yes'),
                PaintDamage: (getState().selfInspect.paintDamage === 'yes'),
                HailDamage: (getState().selfInspect.hailDamage === 'yes'),
                Rebuilt: (getState().selfInspect.carRebuilt === 'yes'),
            }))
            .then(async response => {
                if (response !== "Failure") {
                    await dispatch({
                        type: SET_SELF_INSPECT_DATA, payload: {
                            inspectionId: response,
                        },
                    });
                    if (getState().selfInspect.selectedPersonalCover.product === 2) {
                        await postToController(dispatch, 'SubmitOdoReading', JSON.stringify({
                            RiskItemId: getState().selfInspect.selectedPersonalCover.riskItems[0].chilliDetails.riskItemId,
                            OdoMeterReading: getState().selfInspect.mileage,
                        })).then(async (response) => {
                            if (response === "Failure") {
                                success = false
                            }
                        })
                    }
                    if (success) {
                        var isLastPhoto = false;
                        for (var i = 0; i < getState().selfInspect.photoList.inspectionPhotoTypes.length; i++) {
                            if (success) {
                                for (var k = i + 1; k < getState().selfInspect.photoList.inspectionPhotoTypes.length; k++) {
                                    if (getState().selfInspect.photoList.inspectionPhotoTypes[k].photo === "") {
                                        isLastPhoto = true;
                                    }
                                    else {
                                        isLastPhoto = false;
                                        break;
                                    }
                                }
                                if (i >= getState().selfInspect.photoList.inspectionPhotoTypes.length - 1) {
                                    isLastPhoto = true;
                                }
                                if (getState().selfInspect.photoList.inspectionPhotoTypes[i + 1] && getState().selfInspect.photoList.inspectionPhotoTypes[i + 1].description.toLowerCase() === "mileage reading") {
                                    isLastPhoto = true;
                                }

                                if (getState().selfInspect.photoList.inspectionPhotoTypes[i].photo !== "") {
                                    await postToController(dispatch, 'SubmitPhoto',
                                        JSON.stringify({
                                            Photo: getState().selfInspect.photoList.inspectionPhotoTypes[i].photo,
                                            InspectionId: getState().selfInspect.inspectionId,
                                            RiskItemId: getState().selfInspect.selectedPersonalCover.riskItems[0].riskItemId,
                                            PolicyId: getState().selfInspect.selectedPersonalCover.id,
                                            IsLast: isLastPhoto,
                                            RiskItemType: riskItemType,
                                            Description: getState().selfInspect.photoList.inspectionPhotoTypes[i].description,
                                            PhotoId: getState().selfInspect.photoList.inspectionPhotoTypes[i].id
                                        }))
                                        .then(async response => {
                                            if (response === "Failure") {
                                                success = true
                                            }
                                        })
                                        .catch(err => logErrorToDatabase("Self inspection photo upload error:: " + err))
                                }
                            } else {
                                await dispatch(navigateTo(DASHBOARD));
                                dispatch({
                                    type: MODAL_SHOW,
                                    modalProps: {
                                        type: MODAL_TYPE_ERROR,
                                        header: ERROR_HEADER,
                                        body: ERROR_SOMETHING_WENT_WRONG,
                                    }
                                });
                                break;
                            }
                        }
                        if (success) {

                            await postToController(dispatch, 'GetPolicyDataByCustomerId',
                                JSON.stringify({ Parameter: getState().profile.customerId })).then(async (response) => {
                                    try {
                                        if (response !== "Failure" && response !== "") {
                                            var policyDetails = response[0];
                                            let firstCover = null;
                                            if (policyDetails !== undefined) {
                                                for (var i = 0; i < policyDetails.covers.length; i++) {
                                                    var cover = policyDetails.covers[i];
                                                    if (cover.isMainline === true) {
                                                        firstCover = cover;
                                                        break;
                                                    }
                                                };

                                                await dispatch({
                                                    type: SET_CUSTOMER_DATA, payload: {
                                                        policyId: policyDetails.id,
                                                        countryId: policyDetails.countryId,
                                                        activePolicies: response.length,
                                                        personalPolicies: response,
                                                        selectedPersonalCover: firstCover,
                                                        selectedPersonalPolicy: response[0],
                                                        broker: policyDetails.broker
                                                    }
                                                });

                                                //Filter out completed riskItem from inspection items.
                                                if (getState().profile.inspectionItems?.length > 0) {
                                                    let riskItemId = getState().selfInspect.selectedPersonalCover.riskItems[0].riskItemId;
                                                    let inspectionItems = getState().profile.inspectionItems.filter(x => x.riskItemID !== riskItemId);
                                                    await dispatch({ type: SET_INSPECTION_ITEMS, payload: inspectionItems });
                                                }
                                            }
                                        } else if (response === "Failure") {
                                        }
                                    } catch (err) {
                                        logErrorToDatabase("Error in getPolicyDetails: " + err);
                                    }
                                }).catch((err) => {
                                    logErrorToDatabase("Error in getPolicyDetails catch: " + err);
                                });

                            await dispatch(navigateTo(COMPLETE));
                        }
                    } else {
                        await dispatch(navigateTo(DASHBOARD));

                        await dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        });
                    }

                } else {
                    await dispatch(navigateTo(DASHBOARD));

                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    });
                }
            })
            .catch(err => logErrorToDatabase("Self inspection submission error: " + err))
            .finally(
        )
    }
}

export const showPhotoError = () => {
    return async (dispatch) => {
        await dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_ERROR,
                header: ERROR_HEADER,
                body: ERROR_INSPECTION_PHOTOS,
            }
        });
    }
}

export const getSelfInspectPhotos = () => {
    return async (dispatch, getState) => {
        var riskItemType = 6
        var odoRequired = false
        if (getState().selfInspect.selectedPersonalCover.productName === "Chilli") {
            odoRequired = true
        }
        else if (getState().selfInspect.selectedPersonalCover.productName === "Motorbike") {
            riskItemType = 7
        }
        await postToController(dispatch, 'GetInspectionPhotoTypes',
            JSON.stringify({
                RiskItemType: riskItemType,
                RiskItemId: getState().selfInspect.selectedPersonalCover.riskItems[0].riskItemId,
                IsOdometerTypesRequired: odoRequired,
            }))
            .then(async response => {
                await dispatch({
                    type: SET_SELF_INSPECT_DATA, payload: {
                        photoList: response,
                    },
                });
                dispatch(navigateTo(CAPTURE_IMAGES));
            })
            .catch(err => logErrorToDatabase("Self inspection photo upload error:: " + err))
    }
}

export const savePhoto = (description: string, photo: string, lat: number, lon: number) => {
    return async (dispatch, getState) => {
        var photoList = getState().selfInspect.photoList
        for (var i = 0; i < photoList.inspectionPhotoTypes.length; i++) {
            if (photoList.inspectionPhotoTypes[i].description.toLowerCase() === description.toLowerCase()) {
                photoList.inspectionPhotoTypes[i].photo = photo;
                photoList.inspectionPhotoTypes[i].latitude = lat;
                photoList.inspectionPhotoTypes[i].longitude = lon;
                break;
            }
        }
        await dispatch({
            type: SET_SELF_INSPECT_DATA, payload: {
                photoList: photoList,
            },
        });
        dispatch(navigateTo(CAPTURE_IMAGES));
    }
}

export const sendInspectionSMS = (phoneNumber: string) => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'SendContinueInspectionSms',
            JSON.stringify({
                Parameter: phoneNumber,
            })
        ).catch(err => logErrorToDatabase("Error sending sms: " + err))
    }
}

export const logInspectionContinueOnPhone = () => {
    return async (dispatch, getState) => {

        await postToController(dispatch, 'LogSelInspectContinueOnPhone',
            JSON.stringify({
                CustomerId: getState().profile.customerId,
                RiskItemId: getState().profile.selectedPersonalCover.riskItems[0].id,
            }))
            .then(async response => {
                dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
            })
            .catch(err => logErrorToDatabase("Error logging claim continue: " + err))
    }
}

export const getInspectionContinueAndSetData = () => {
    return async (dispatch, getState) => {
        await dispatch({ type: LOADING_SCREEN_SHOW });

        await postToController(dispatch, 'GetSelfInspectDataDataAndRemoveCheck',
            JSON.stringify({
                Parameter: getState().profile.customerId,
            }))
            .then(async dataResponse => {
                dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });

                var policies = getState().profile.selectedPersonalPolicy;
                var selectedCover = [];
                var selectedCoverId = "";
                var selectedCoverProduct = 0;
                var selectedIncident = [];
                var selectedIncidentId = 0;
                if (policies !== undefined) {
                    for (var i = 0; i < policies.covers.length; i++) {
                        var cover = policies.covers[i];
                        if (cover.id === dataResponse.riskItemId) {
                            selectedCover = cover;
                            selectedCoverId = cover.id
                            selectedCoverProduct = cover.product
                            break;
                        }
                    };

                    await dispatch({
                        type: SET_SELF_INSPECT_DATA, payload: {
                            selectedPersonalCover: selectedCover,
                        },
                    });
                    await dispatch(navigateTo(SELF_INSPECTION));
                }
            })
            .catch(err => logErrorToDatabase("Iveri Submission Error: " + err))
        await dispatch({ type: LOADING_SCREEN_HIDE });
    }
}

export const removeInspectionNotifyFlag = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'RemoveSelfInspectContinueCheck',
            JSON.stringify({
                Parameter: getState().profile.customerId,
            }))
            .then(async response => {
                dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
            })
            .catch(err => logErrorToDatabase("Iveri Submission Error: " + err))
    }
}

export const toggleSelfInspectPhotos = (value: boolean) => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_SELF_INSPECT_DATA, payload: {
                showSelfInspectPhotos: value
            },
        });
    }
}

export const toggleHasError = (value: boolean) => {
    return async (dispatch) => {
        await dispatch({
            type: SET_SELF_INSPECT_DATA, payload: {
                hasError: value
            },
        });
    }
}